import React from 'react'
import { UsageLimit } from '.'
import { Loader } from 'shared/components/Loader'
import { Link } from 'react-router-dom'
import { AllowPermission } from 'shared/components/AllowPermission'
import useAxios from 'hooks/useAxios'
import { Form } from 'semantic-ui-react'
import * as R from 'ramda'
import useWorkspace from 'hooks/useWorkspace'
import constants from 'config/constants'

export function UsageLimitContainer() {
  const { data: usageLimitData, loading: usageLimitloading } = useAxios({
    method: 'get',
    url: `account/usage-data/`,
  })

  if (usageLimitloading) {
    return <Loader withContainer />
  }

  const usageLimitEnd = new Date(R.prop('usage_end', usageLimitData))
  const currentPeriodEnd = new Date(R.prop('current_period_end', usageLimitData))
  const subscriptionStatus = R.prop('status', usageLimitData)

  if (subscriptionStatus !== 'active' && subscriptionStatus !== 'trialing') {
    return <InactiveUsageLimitSection subscriptionStatus={subscriptionStatus} />
  }

  const filteredUsageLimits = (usageLimitData = { usage_limits: [] }, subscriptionStatus = '') => {
    const isTrialing = subscriptionStatus === 'trialing'
    const excludedFeatures = ['Monthly email sends']
    if (isTrialing && Array.isArray(usageLimitData.usage_limits)) {
      return {
        ...usageLimitData,
        usage_limits: usageLimitData.usage_limits.filter(
          (limit) => !excludedFeatures.includes(limit.feature_name)
        ),
      }
    }
    return usageLimitData
  }
  return (
    <React.Fragment>
      <Form>
        <PlanSection usageLimitData={usageLimitData} date={currentPeriodEnd} />
        <UsageSection
          usageLimitData={filteredUsageLimits(usageLimitData, subscriptionStatus)}
          date={usageLimitEnd}
        />
        <Footer />
      </Form>
    </React.Fragment>
  )
}

const PlanSection = ({ usageLimitData, date }) => {
  const workspaceToken = useWorkspace()
  return (
    <React.Fragment>
      <h2>Your plan</h2>
      <p>
        Your Simplesat account is on the <strong>{usageLimitData.plan}</strong> plan, billed{' '}
        <strong>{usageLimitData.interval}ly</strong>.
      </p>
      <AllowPermission permission={constants.permissions.viewBillingPage}>
        <Link to={`/${workspaceToken}/settings/billing/`}>Change plan details</Link>
      </AllowPermission>

      <p>
        Your plan will renew on{' '}
        <strong>
          {date.toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
          })}
          .
        </strong>
      </p>
    </React.Fragment>
  )
}

const Footer = () => {
  return (
    <div className="w-full text-center footer-link">
      <a href="https://www.simplesat.io/pricing/" target="_blank" rel="noopener">
        See all features available on your plan
      </a>
    </div>
  )
}

const UsageSection = ({ usageLimitData, date }) => {
  const today = new Date()
  const timeDiff = date.getTime() - today.getTime()
  const daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24))
  return (
    <React.Fragment>
      <h2>Usage</h2>
      <p>
        Features with monthly usage quotas will reset on{' '}
        <strong>
          {date.toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
          })}
        </strong>{' '}
        ({daysLeft} days)
      </p>

      <a
        href="https://help.simplesat.io/en/articles/1754490-plans-and-billing-overview"
        target="_blank"
        rel="noopener"
      >
        <i className="icon far fa-book" />
        More about Simplesat plans and billing
      </a>
      <UsageLimit usage={usageLimitData} />
    </React.Fragment>
  )
}

function convertSnakeCaseToUpperCase(message) {
  if (message) {
    const result = message.replace(/_/g, ' ').toLowerCase()
    return result.charAt(0).toUpperCase() + result.slice(1)
  } else {
    return 'Unknown'
  }
}

const InactiveUsageLimitSection = ({ subscriptionStatus }) => {
  const workspaceToken = useWorkspace()
  return (
    <div className="plan-details">
      <h2>Your plan</h2>
      <p className="mb-0">
        Your subscription status is:
        <span className="bold"> {convertSnakeCaseToUpperCase(subscriptionStatus)}</span>.
        <AllowPermission permission={constants.permissions.viewBillingPage}>
          {' '}
          To resume service with Simplesat, please{' '}
          <Link to={`/${workspaceToken}/settings/billing/`}>choose a plan</Link>.
        </AllowPermission>
      </p>
    </div>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/UsageLimit/container.js